import classNames from 'classnames';
import styles from './ScommesseGridMultiple.module.scss';

export type ScommesseGridMultipleProps = {
  className?: string;
  children: React.ReactNode;
  noPaddingTop?: boolean;
};

const ScommesseGridMultiple = ({ className, children, noPaddingTop }: ScommesseGridMultipleProps) => (
  <div className={classNames(styles.container, className, { [styles.noPaddingTop]: noPaddingTop })}>{children}</div>
);

const Row = ({ children, index }: { children: React.ReactNode; index: number }) => (
  <div className={classNames(styles.row, { [styles.rowFirst]: index === 0 })}>{children}</div>
);

ScommesseGridMultiple.Row = Row;

export { ScommesseGridMultiple };
